import { useState, useEffect, useCallback } from 'react';
import {
  collection, query, where, getDocs, updateDoc, setDoc, doc,
} from 'firebase/firestore';
import { db } from '../firebase';
import { toast } from "sonner";

const TASK_POOL = [
  { id: 'task1', description: '30 dakika Matematik çalış', type: 'study', goal: 1800 },
  { id: 'task2', description: '5 soru çöz', type: 'quiz', goal: 5 },
  { id: 'task3', description: '1 deneme sınavı yap', type: 'exam', goal: 1 },
  { id: 'task4', description: '1 saat odaklan', type: 'study', goal: 3600 },
];

export function useDailyTasks(userId, userState = {}) {
  const { xp, badges, setXp, setLevel, setBadges } = userState;
  const [tasks, setTasks] = useState([]);
  const [rewardsClaimed, setRewardsClaimed] = useState(false);
  const [loading, setLoading] = useState(true);

  const createDailyTasks = useCallback(async () => {
    if (!userId) return;
    const today = new Date().toISOString().split('T')[0];
    const randomTask = TASK_POOL[Math.floor(Math.random() * TASK_POOL.length)];
    const taskDoc = {
      userId, date: today,
      tasks: [{ ...randomTask, completed: false }],
      rewardsClaimed: false,
    };
    await setDoc(doc(db, 'dailyTasks', `${userId}-${today}`), taskDoc);
    setTasks(taskDoc.tasks);
    setRewardsClaimed(false);
  }, [userId]);

  useEffect(() => {
    if (!userId) { setLoading(false); return; }
    (async () => {
      try {
        const today = new Date().toISOString().split('T')[0];
        const q = query(collection(db, 'dailyTasks'), where('userId', '==', userId), where('date', '==', today));
        const snap = await getDocs(q);
        if (snap.empty) { await createDailyTasks(); }
        else { const d = snap.docs[0].data(); setTasks(d.tasks); setRewardsClaimed(d.rewardsClaimed); }
      } catch (err) { console.error('useDailyTasks:', err); }
      finally { setLoading(false); }
    })();
  }, [userId, createDailyTasks]);

  const completeTask = async () => {
    if (!userId || !tasks.length || !setXp) return;
    const today = new Date().toISOString().split('T')[0];
    const taskRef = doc(db, 'dailyTasks', `${userId}-${today}`);
    const userRef = doc(db, 'users', userId);
    const updated = tasks.map((t) => ({ ...t, completed: true }));
    await updateDoc(taskRef, { tasks: updated });
    setTasks(updated);
    if (updated.every((t) => t.completed) && !rewardsClaimed) {
      const newXp = (xp || 0) + 50;
      const newLevel = Math.floor(newXp / 100) + 1;
      const newBadges = [...(badges || [])];
      if (!newBadges.includes('TaskMaster')) newBadges.push('TaskMaster');
      await updateDoc(taskRef, { rewardsClaimed: true });
      await updateDoc(userRef, { xp: newXp, level: newLevel, badges: newBadges });
      setRewardsClaimed(true);
      setXp(newXp); setLevel(newLevel); setBadges(newBadges);
      toast.success('Görev tamamlandı! 50 XP kazandın! 🎉');
    }
  };

  return { tasks, rewardsClaimed, loading, completeTask, createDailyTasks };
}
